class ESPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.debounceTimer = null;
    this.sectionId = this.getAttribute('section-id');
    // Define fallback for routes in case not present globally
    this.routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    
    this.onInput = this.onInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.resultsSlot = this.querySelector('[slot="results"]');
    this.form = this.querySelector('form');
    
    if (this.input) this.input.addEventListener('input', this.onInput);
    if (this.form) this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    if (this.input) this.input.removeEventListener('input', this.onInput);
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    if (this.abortController) this.abortController.abort();
  }

  onSubmit(evt) {
    if (!this.input.value.trim()) {
      evt.preventDefault();
    }
  }

  onInput(evt) {
    const query = this.input.value.trim();
    
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    
    if (!query) {
      if (this.abortController) this.abortController.abort();
      this.resultsSlot.innerHTML = '';
      this.removeAttribute('loading');
      return;
    }

    this.debounceTimer = setTimeout(() => {
      this.fetchResults(query);
    }, 300);
  }

  async fetchResults(query) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    const currentSignal = this.abortController.signal;

    this.setAttribute('loading', '');
    
    try {
      const response = await fetch(`${this.routesRoot}search/suggest?q=${encodeURIComponent(query)}&section_id=${this.sectionId}&resources[type]=product,query,article,collection,page`, {
        signal: currentSignal
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const results = html.querySelector(`[section-id="${this.sectionId}"] [slot="results"]`);

      if (results && !currentSignal.aborted) {
        this.resultsSlot.innerHTML = results.innerHTML;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Predictive search error:', error);
      }
    } finally {
      if (!currentSignal.aborted) {
        this.removeAttribute('loading');
      }
    }
  }
}

if (!customElements.get('es-predictive-search')) {
  customElements.define('es-predictive-search', ESPredictiveSearch);
}
